import 'rc-tooltip/assets/bootstrap.css';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import RcTooltip from 'rc-tooltip';

const Tooltip = forwardRef((props, ref) => {
  let overlay;
  if (props.text) {
    overlay = <span>{props.text}</span>;
  } else if (props.node) {
    overlay = props.node;
  }

  if (overlay) {
    return (
      <RcTooltip
        ref={ref}
        placement={props.placement}
        mouseEnterDelay={0.2}
        mouseLeaveDelay={0.2}
        destroyTooltipOnHide
        trigger={['hover', 'click']}
        overlay={overlay}
        align={{
          offset: [0, 0],
        }}
        transitionName="rc-tooltip-zoom"
      >
        {props.children}
      </RcTooltip>
    );
  }

  return props.children;
});

Tooltip.propTypes = {
  placement: PropTypes.string,
  text: PropTypes.string,
  node: PropTypes.node,
  children: PropTypes.node,
};

Tooltip.defaultProps = {
  placement: 'right',
};

export default Tooltip;
